import React, { useEffect } from 'react';
import { ListGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import { ROUTES } from '../profileInfo/constant/Routes';
import { getDeposit, set_me } from '../../actions/user';
import { getBasket } from '../../actions/cartActions';
import { connect } from 'react-redux';
import { ENABLE_GOLD_WALLET_IN_CART } from '../../themeSetting';
import { getGoldGramDeductionToman, applyGoldGramDeduction } from '../../helper';
import WalletCreditDisplay from '../../core-component/WalletCreditDisplay';

const Invoice = ({ set_me, getBasket, getDeposit }) => {
  const translate = useSelector((state) => getTranslate(state.localize));
  const cart_report = useSelector((state) => state.cart.cart_report);
  const credit = useSelector((state) => state.cart.cart_credit);
  const user = useSelector((state) => state.user);
  const price_shipping = useSelector((state) => state.cart.price_shipping);
  const order_shipping = useSelector((state) => state.cart.order_shipping);
  const deposit_price = useSelector((state) => state.deposit_price);
  const pay_type = useSelector((state) => state.pay_type);
  const discount = useSelector((state) => state.discount);
  const discountCode = useSelector((state) => state.discountCode);
  const gold_gram_cart_usage = useSelector((state) => state.cart.gold_gram_cart_usage) || 0;
  const gold = useSelector((state) => state.gold_price) || 0;

  const goldGramDeductionToman = getGoldGramDeductionToman(gold_gram_cart_usage, gold);

  useEffect(() => {
    set_me();
    getBasket();
    getDeposit();
  }, []);

  const cart_items_team = [
    {
      name: 'total_weight',
      render: <NumberFormat value={cart_report?.total_weight} suffix={' ' + translate('weight-unit')} displayType={'text'} thousandSeparator={true} />,
      value: cart_report?.total_weight,
    },
    {
      name: 'total_make_pay',
      render: <NumberFormat value={cart_report?.total_make_pay} suffix={' ' + translate('price-unit')} displayType={'text'} thousandSeparator={true} />,
      value: cart_report?.total_make_pay,
    },
    {
      name: 'total_kaser',
      render: <NumberFormat value={cart_report?.total_kaser} suffix={' ' + translate('weight-unit')} displayType={'text'} thousandSeparator={true} />,
      value: cart_report?.total_kaser,
    },
    {
      name: 'total_gr',
      render: <NumberFormat value={cart_report?.total_gr} suffix={' ' + translate('weight-unit')} displayType={'text'} thousandSeparator={true} />,
      value: cart_report?.total_gr,
    },
    {
      name: 'total_discount',
      render: <NumberFormat value={cart_report?.total_discount} suffix={' ' + translate('weight-unit')} displayType={'text'} thousandSeparator={true} />,
      value: cart_report?.total_discount,
    },
  ];

  const cart_customer = [
    {
      name: 'credit-plus',
      render: <WalletCreditDisplay credit={credit} suffix={` ${translate('price-unit')}`} />,
      value: credit / 10,
    },
    {
      name: 'total_price',
      render: <NumberFormat value={cart_report?.total_price} suffix={translate('price-unit')} displayType={'text'} thousandSeparator={true} />,
      value: cart_report?.total_price,
    },
  ];

  const cart_items = user?.is_teammate ? cart_items_team : cart_customer;

  return (
    <div className='invoice rtl my-3 invoice-order-detail custom-margin-bottom'>
      <ListGroup as='ul' className='px-0'>
        <ListGroup.Item className={'d-flex justify-content-between'} variant={'light'} style={{ backgroundColor: 'lightgrey' }}>
          <div className='c-invoice-header'>{translate('order-details')}</div>
          <div className='c-total-cost'></div>
        </ListGroup.Item>

        {cart_items.map((obj, index) => {
          if (obj.name === 'credit-plus') {
            return (
              <ListGroup.Item key={index} className='d-flex justify-content-between border-bottom'>
                <Link to={ROUTES.CHARGING_WALLET}>
                  <h5 className='c-font-sm'>{translate(obj.name)}</h5>
                </Link>
                <span className='c-font-xs text-end d-block'>{obj.render}</span>
              </ListGroup.Item>
            );
          }
          return (
            <ListGroup.Item key={index} className='d-flex justify-content-between border-bottom'>
              <h5 className='c-font-sm'>{translate(obj.name)}</h5>
              <span className='c-font-xs'>{obj.render}</span>
            </ListGroup.Item>
          );
        })}

        {discount?.amount && (
          <ListGroup.Item className='d-flex justify-content-between border-bottom'>
            <h5 className='c-font-sm'>تخفیف اعمال شده با کد {discountCode}</h5>
            <NumberFormat value={discount.amount / 10} displayType={'text'} suffix=' تومان ' thousandSeparator={true} />
          </ListGroup.Item>
        )}

        {ENABLE_GOLD_WALLET_IN_CART && gold_gram_cart_usage > 0 && (
          <ListGroup.Item className='d-flex justify-content-between border-bottom'>
            <h5 className='c-font-sm' style={{ color: '#01494b' }}>
              کسر از موجودی گرمی ({parseFloat(gold_gram_cart_usage).toFixed(2)} گرم)
            </h5>
            <span className='c-font-xs' style={{ color: '#dc3545' }}>
              − <NumberFormat value={goldGramDeductionToman} displayType='text' suffix=' تومان' thousandSeparator={true} />
            </span>
          </ListGroup.Item>
        )}

        {price_shipping !== null && order_shipping && (
          <ListGroup.Item className='d-flex justify-content-between border-bottom'>
            <h5 className='c-font-sm'>{order_shipping === '2' ? 'هزینه بیمه محصولات:' : 'زمان و هزینه ارسال:'}</h5>
            <span className='c-font-xs mr-4'>
              {price_shipping === 0 || price_shipping === '0' ? (
                order_shipping === 1 ? (
                  'زمان ارسال برای تهران تا دو روز کاری و برای شهرستان دو تا سه روز کاری می‌باشد. همکاران ما قبل از ارسال با شما تماس خواهند گرفت.'
                ) : (
                  ' رایگان است '
                )
              ) : (
                <NumberFormat value={price_shipping} displayType={'text'} suffix=' تومان ' thousandSeparator={true} />
              )}
            </span>
          </ListGroup.Item>
        )}

        {user?.is_teammate !== 1 && (
          <ListGroup.Item className='d-flex justify-content-between border-bottom'>
            <h5 className='c-font-sm'>{translate('total_all')}</h5>
            <span className='c-font-xs'>
              <NumberFormat
                value={applyGoldGramDeduction(
                  (parseFloat(price_shipping || 0) + parseFloat(cart_report?.total_price || 0)).toFixed(0) -
                    parseFloat(discount?.amount / 10 || 0) -
                    credit / 10,
                  gold_gram_cart_usage,
                  gold,
                )}
                displayType={'text'}
                suffix={'تومان'}
                thousandSeparator={true}
              />
            </span>
          </ListGroup.Item>
        )}

        {deposit_price !== 0 && pay_type === 'deposit' && (
          <ListGroup.Item className='d-flex justify-content-between border-bottom'>
            <div className='c-font-sm'>
              <p className='m-0'>مبلغ قابل پرداخت:</p>
              <p className='c-font-xs'>با احتساب بیعانه</p>
            </div>
            <span className='c-font-xs mr-4'>
              {(() => {
                let amount;
                if (credit <= 0) {
                  amount = deposit_price;
                } else if (deposit_price - credit / 10 <= 0) {
                  return 'برداشت از کیف پول';
                } else {
                  amount = deposit_price - credit / 10;
                }
                const finalAmount = applyGoldGramDeduction(amount, gold_gram_cart_usage, gold);
                return finalAmount <= 0 ? (
                  'برداشت از کیف پول'
                ) : (
                  <NumberFormat value={finalAmount} displayType={'text'} suffix={'تومان'} thousandSeparator={true} />
                );
              })()}
            </span>
          </ListGroup.Item>
        )}
      </ListGroup>
    </div>
  );
};

const MapStateToProps = (state) => {
  return {};
};

export default connect(MapStateToProps, { set_me, getBasket, getDeposit })(Invoice);
